export default "__VITE_ASSET__DWgtjHNt__"